import React, { memo } from 'react'

import imgSuccess from './img/success.png'
import imgInfo from './img/info.png'
import imgWarning from './img/warning.png'
import imgError from './img/error.png'

import css from './notification.module.scss'
import { Button } from '../button'
import { useManagedTimers } from '@hooks/useManagedTimers'
import { SafeMessage } from '../safe-message'


/** Всплывающее сообщение */
export default memo((props: any) => {
    const [exit, setExit] = React.useState(false)
    const closeTimeoutID = React.useRef<ReturnType<typeof setTimeout> | null>(null)
    const isClosingRef = React.useRef(false)

    const { setManagedTimeout, clearManagedTimeout } = useManagedTimers()

    const handleCloseNotification = () => {
        if (isClosingRef.current) return

        isClosingRef.current = true
        clearManagedTimeout(closeTimeoutID.current)
        setExit(true)

        closeTimeoutID.current = setManagedTimeout(() => {
            props.dispatch({
                type: 'REMOVE_NOTIFICATION',
                id: props.id
            })
        }, 400)
    }

    React.useEffect(() => {
        return () => clearManagedTimeout(closeTimeoutID.current)
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    const duration = Math.max(1000, Number(props.duration) || 5000)

    return (
        <div className={`${css.notificationSuccess} ${exit ? css.exit : ''}`}
            style={{ background: `${props.type === 'success' ? '#00CC99' : props.type === 'info' ? '#5458F7' : props.type === 'warning' ? '#F2C94C' : props.type === 'error' ? '#EB5757' : '#fff'}` }}>

            <div className={css.notificationContent}>
                <Button variant='iconPrimary' size='xs' onClick={handleCloseNotification}>
                    <svg width="18" height="18" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clipPath="url(#clip0_239_32)">
                            <path d="M20.5833 6.94417L19.0558 5.41667L13 11.4725L6.94413 5.41667L5.41663 6.94417L11.4725 13L5.41663 19.0558L6.94413 20.5833L13 14.5275L19.0558 20.5833L20.5833 19.0558L14.5275 13L20.5833 6.94417Z" fill="currentColor" />
                        </g>
                        <defs>
                            <clipPath id="clip0_239_32">
                                <rect width="26" height="26" fill="currentColor" />
                            </clipPath>
                        </defs>
                    </svg>
                </Button>

                <img src={
                    props.type === 'success' ? imgSuccess :
                    props.type === 'info' ? imgInfo :
                    props.type === 'warning' ? imgWarning :
                    props.type === 'error' ? imgError :
                    ''} alt="Тип сообщения"
                />

                <div className={css.message}><SafeMessage message={props.message} /></div>
                <div className={css.barContainer}>
                    <div className={css.bar} style={{ animationDuration: `${duration}ms` }} onAnimationEnd={handleCloseNotification}></div>
                </div>
            </div>
        </div>
    )
})